module.exports = __webpack_public_path__ + "static/media/left.b9704522.svg";